/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import model from "./pipe.glb";

export default function Pipe(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh
          name="PipeExtension"
          geometry={nodes.PipeExtension.geometry}
          material={materials.Metal}
          position={[-2.7, 6.89, -80.13]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
